import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateServiceSchema } from '@/utils/seo';
import ServicePageLayout, { ServicePageConfig } from '@/pages/service-common/ServicePageLayout';

/* ─── Hero Background ─── */
const HERO_IMG = 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20golden%20growth%20chart%20and%20upward%20arrows%20with%20data%20points%20on%20deep%20navy%20blue%20background%20minimal%20sophisticated%20high-end%20corporate%20aesthetic%20soft%20glowing%20particles%20no%20text&width=1920&height=800&seq=mkthero1&orientation=landscape';

const config: ServicePageConfig = {
  pageLabel: 'マーケティングコンサルティング',
  heroImage: HERO_IMG,
  tag: 'Marketing Consulting',
  title: <>データ駆動型<br />マーケティング戦略</>,
  subtitle: '市場分析から戦略立案・実行支援まで。ビジネス目標に直結するマーケティング戦略を設計し、測定可能な成果を継続的に創出します。',
  icon: 'ri-megaphone-line',
  services: [
    { icon: 'ri-search-eye-line', title: '市場調査・競合分析', desc: '深度ある市場調査と競合インテリジェンスで戦略の基盤を構築します。' },
    { icon: 'ri-award-line', title: 'ブランド戦略', desc: '魅力的なブランドポジショニングとメッセージングフレームワークを開発します。' },
    { icon: 'ri-calendar-todo-line', title: 'マーケティング計画', desc: 'ビジネス目標と連動した包括的なマーケティング計画を策定します。' },
    { icon: 'ri-lightbulb-line', title: 'キャンペーン開発', desc: 'クリエイティブで戦略的なキャンペーンを設計・実行します。' },
    { icon: 'ri-line-chart-line', title: 'パフォーマンス最適化', desc: 'マーケティング効果を継続的に測定・改善するPDCAサイクルを構築します。' },
    { icon: 'ri-tools-line', title: 'マーケティングテクノロジー', desc: '最適なマーケティングツールの選定と導入・活用を支援します。' },
  ],
  steps: [
    { title: 'ディスカバリー・現状把握', desc: 'ビジネス・市場・目標を深く理解し、課題を明確化します。' },
    { title: '戦略設計', desc: '貴社固有のニーズに合わせたデータドリブンな戦略を策定します。' },
    { title: '実行支援', desc: '専門家によるハンズオンサポートでスムーズな実行を後押しします。' },
    { title: '測定・継続改善', desc: 'パフォーマンスを追跡し、より良い成果に向けて継続的に最適化します。' },
  ],
  benefits: [
    '133件以上の実績に裏打ちされた確かなマーケティング支援',
    '高度な分析能力に基づくデータドリブンなアプローチで確実な成果を創出',
    'マーケティングのあらゆる側面を網羅した統合型ソリューションを提供',
    '業界を深く理解したマーケティング戦略家チームによる専門的なサポート',
    '投資対効果（ROI）を最大化するための透明性の高いレポーティング',
    '短期成果と中長期的なブランド構築を両立した戦略設計',
  ],
};

export default function MarketingConsultingPage() {
  useSEO({
    title: '東京 マーケティングコンサルティング TradFit株式会社 | データ駆動型戦略',
    description: 'TradFit株式会社のマーケティングコンサルティングサービス。市場分析から戦略立案・実行支援まで、ビジネス目標に直結するマーケティング戦略を設計します。',
    keywords: 'マーケティングコンサルティング, データマーケティング, ブランド戦略, 東京',
    path: '/marketing-consulting',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema('マーケティングコンサルティング | TradFit株式会社', 'TradFit株式会社のマーケティングコンサルティングサービス。', '/marketing-consulting'),
        generateBreadcrumbSchema([{ name: 'ホーム', path: '/' }, { name: '事業内容', path: '/business' }, { name: 'マーケティングコンサルティング', path: '/marketing-consulting' }]),
        generateServiceSchema('マーケティングコンサルティング', '市場分析から戦略立案・実行支援までのマーケティングコンサルティングサービス。'),
      ],
    },
  });
  return <ServicePageLayout config={config} />;
}
